import React from "react";
import BondPlayInfoModal from "./BondPlayInfoModal";
import { DEFAULT_BOND_WHEEL_CONSTANTS, formatCoin } from "../../utils/bondWheelHelpers";

const BondWheelInfoModal = ({ open = false, onClose, constants = DEFAULT_BOND_WHEEL_CONSTANTS }) => {
  const minEntry = constants?.minEntryAmount || DEFAULT_BOND_WHEEL_CONSTANTS.minEntryAmount;
  const lockMinutes = constants?.lockBeforeDeadlineMinutes || DEFAULT_BOND_WHEEL_CONSTANTS.lockBeforeDeadlineMinutes;
  const platformFee = Math.round((constants?.platformFeeRate || 0.05) * 100);
  const creatorFee = Math.round((constants?.creatorFeeRate || 0.02) * 100);

  return (
    <BondPlayInfoModal
      open={open}
      onClose={onClose}
      titleId="bplay-wheel-info-title"
      title="Bond Wheel"
      subtitle="Create or join a wheel, hit the minimum by deadline, then spin for winners."
      sections={[
        {
          title: "Getting in",
          items: [
            <>Host a wheel or join one live before lock. Each player gets a slice — extra tickets mean a bigger slice.</>,
          ],
        },
        {
          title: "Minimum & lock",
          items: [
            <>Minimum players must be greater than twice the winner count. Too few by deadline? Everyone is refunded.</>,
            <>Joining closes {lockMinutes} min before the deadline. Leave before lock for a full refund.</>,
          ],
        },
        {
          title: "Result",
          items: [
            <>If the minimum is met, the wheel spins and picks the winner(s). They split the pot equally.</>,
            <>Entry from {formatCoin(minEntry)} COIN. Platform ({platformFee}%) and host ({creatorFee}%) fees apply to each winner&apos;s profit.</>,
          ],
        },
      ]}
    />
  );
};

export default BondWheelInfoModal;
